<template>
    <BaseModal
        :is-open="isOpen"
        @modal-close="closeModal"
        :is-loading="isStatusLoading"
        content-wrapper-class="user-questionnaire-modal"
        identifier="user-questionnaire"
    >
        <div id="promiseCaptchaContainer"></div>
    </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal';
import { testIsNonEmptyString, testIsNotNull, testIsNull } from '../../../../lib/test-and-assert/test-base';
import { pageStoreMixin } from '../../../store/page-store';
import { getLocationHashWithoutModalPageFragment } from '../register_payment_flow/modal-fragment-helper';
import { userQuestionnaireModalHelper } from './user-questionnaire-modal-helper';

export default {
    name: 'UserQuestionnaireFormModal',
    components: { BaseModal },
    mixins: [pageStoreMixin],
    beforeMount() {
        window.addEventListener('beforeunload', this.onBeforeUnload);
    },
    mounted() {
        this.registerEvents();

        let fragmentData = qgQueryFragmentHelper.getCurrentFragmentData();

        if (fragmentData['questionnaire_modal']) {
            userQuestionnaireModalHelper.openProjectUsage();
        }
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
    },
    methods: {
        onBeforeUnload() {
            // to prevent users being stuck in an invalid state we need to set submitting to false before unloading
            this.store.questionnaireModal.setSubmitting(false);
        },
        closeModal() {
            this.store.questionnaireModal.close();
        },
        registerEvents() {
            this.$router.afterEach((to, from) => {
                if (!testIsNonEmptyString(from?.name)) {
                    // do not commit page change if modal opens
                    return;
                }

                this.store.questionnaireModal.changePage({
                    fromPage: from.name,
                    toPage: to.name,
                });
            });
        },
    },
    computed: {
        openPage() {
            return this.store.questionnaireModal.getOpenPage;
        },
        isOpen() {
            return this.openPage !== null;
        },
        /** @return {Boolean} */
        isSubmitting() {
            return this.store.questionnaireModal.getSubmitting;
        },
        /** @return {User} */
        storeUser() {
            return this.store.user.getUser;
        },
    },
    watch: {
        openPage: function (page, pageOld) {
            if (testIsNotNull(page) && testIsNotNull(pageOld)) {
                // skip if we switch from one modal page to another
                return;
            }

            // if the old page is null and the new page is a string the modal is opening
            if (testIsNull(pageOld) && testIsNonEmptyString(page)) {
                window.location.hash = getLocationHashWithoutModalPageFragment();

                let openPage = page;

                if (this.$router.currentRoute?.name !== openPage) {
                    this.$router.push({ name: openPage });
                }
            }
        },
    },
    data() {
        return {
            // isOpen: false,
            isStatusLoading: false,
        };
    },
};
</script>

<style lang="scss">
.user-questionnaire-modal .user-questionnaire-form-container {
    width: 100%;
    max-width: 480px;
}
</style>
